import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Atendimentos } from '@/features/atendimentos/componentes/Atendimentos';
import { rotaDeTela } from '@/features/permissoes/guardas';

const id = z.uuid().optional().catch(undefined);
const dia = z.iso.date().optional().catch(undefined);
const busca = z.object({
  alunoId: id,
  tipoId: id,
  planoId: id,
  de: dia,
  ate: dia,
  agrupar: z.boolean().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
});

/** Atendimentos (spec 010, CA-01). */
export const Route = createFileRoute('/_autenticado/atendimentos/')({
  ...rotaDeTela('atendimentos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Atendimentos
      busca={valores}
      aoMudarBusca={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
